import { render, staticRenderFns } from "./NewScanTable.vue?vue&type=template&id=93864ba6"
import script from "./NewScanTable.vue?vue&type=script&lang=js"
export * from "./NewScanTable.vue?vue&type=script&lang=js"
import style0 from "./NewScanTable.vue?vue&type=style&index=0&id=93864ba6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports